"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var h = require("./../../utils/createElement").h;
var React = tslib_1.__importStar(require("react"));
var helper_1 = require("../../utils/helper");
var theme_1 = require("../../utils/theme");
var Slider = (function (_super) {
    tslib_1.__extends(Slider, _super);
    function Slider(props) {
        var _this = _super.call(this, props) || this;
        _this.containerRef = React.createRef();
        _this._dragging = false;
        _this.handleTouchStart = function (event) {
            _this._prevTouchPosition = _this.getEventPosition(event);
            _this._dragging = true;
            event.stopPropagation();
        };
        _this.handleTouchMove = function (event) {
            if (!_this._dragging) {
                return;
            }
            var touchPosition = _this.getEventPosition(event);
            var moveDistance = (_this.isHorizontal ? 1 : -1) * (touchPosition - _this._prevTouchPosition);
            var _a = _this.setStateByPosition(_this.getCurrentPosition() + moveDistance), isValid = _a.isValid, roundedOffset = _a.roundedOffset;
            if (isValid) {
                _this._prevTouchPosition = touchPosition + roundedOffset;
            }
            event.stopPropagation();
            event.cancelable && event.preventDefault();
        };
        _this.handleTouchTerminate = function () {
            if (_this._dragging) {
                _this._dragging = false;
                _this.props.onChangeEnd(_this.state.currentValue);
            }
        };
        _this.handleContainerClick = function (event) {
            event.stopPropagation();
            var pos = (_this.isHorizontal ? 1 : -1) * (_this.getEventPosition(event) - _this.getStartPosition());
            _this.setStateByPosition(pos, _this.props.onChangeEnd);
        };
        _this.handleDragClick = function (event) {
            event.stopPropagation();
        };
        _this.themedRender = function (classNames) {
            var _a, _b;
            var _c = _this.props, prefixCls = _c.prefixCls, className = _c.className, style = _c.style, dragStyle = _c.dragStyle, dragClassName = _c.dragClassName, fillStyle = _c.fillStyle, fillClassName = _c.fillClassName, barStyle = _c.barStyle, barClassName = _c.barClassName, orientation = _c.orientation;
            var currentValue = _this.state.currentValue;
            var classes = classNames(prefixCls, className, prefixCls + "-" + orientation);
            var percentage = _this.getValuePercentage(currentValue);
            var mergedfillStyle = tslib_1.__assign(tslib_1.__assign({}, fillStyle), (_a = {}, _a[_this.isHorizontal ? 'width' : 'height'] = percentage * 100 + "%", _a));
            var mergedDragStyle = tslib_1.__assign(tslib_1.__assign({}, dragStyle), (_b = {}, _b[_this.isHorizontal ? 'left' : 'bottom'] = percentage * 100 + "%", _b));
            return (h("div", { className: classes, style: style, ref: _this.containerRef, onClick: _this.handleContainerClick },
                h("div", { style: barStyle, className: classNames(prefixCls + "-bar", barClassName) },
                    h("div", { className: classNames(prefixCls + "-fill", fillClassName), style: mergedfillStyle }),
                    h("div", { className: classNames(prefixCls + "-drag", dragClassName), style: mergedDragStyle, onTouchStart: _this.handleTouchStart, onClick: _this.handleDragClick }))));
        };
        _this.checkParams();
        _this.state = {
            currentValue: typeof props.defaultValue === 'number' ? props.defaultValue : props.min
        };
        return _this;
    }
    Slider.getDerivedStateFromProps = function (props, state) {
        var value = props.value, min = props.min, max = props.max;
        if (typeof value === 'number') {
            return { currentValue: helper_1.castInto(value, [min, max]) };
        }
        return null;
    };
    Object.defineProperty(Slider.prototype, "valueSpan", {
        get: function () {
            return this.props.max - this.props.min;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Slider.prototype, "isHorizontal", {
        get: function () {
            return this.props.orientation === 'horizontal';
        },
        enumerable: false,
        configurable: true
    });
    Slider.prototype.getCurrentPosition = function () {
        return this.getLength() * this.getValuePercentage(this.state.currentValue);
    };
    Slider.prototype.getLength = function () {
        var _a;
        var _b = ((_a = this.containerRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect()) || {}, _c = _b.width, width = _c === void 0 ? 0 : _c, _d = _b.height, height = _d === void 0 ? 0 : _d;
        return this.isHorizontal ? width : height;
    };
    Slider.prototype.getStartPosition = function () {
        var _a;
        var _b = ((_a = this.containerRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect()) || {}, _c = _b.left, left = _c === void 0 ? 0 : _c, _d = _b.bottom, bottom = _d === void 0 ? 0 : _d;
        return this.isHorizontal ? left : bottom;
    };
    Slider.prototype.componentDidMount = function () {
        var dom = this.containerRef.current;
        dom.addEventListener('touchmove', this.handleTouchMove);
        dom.addEventListener('touchend', this.handleTouchTerminate);
        dom.addEventListener('touchcancel', this.handleTouchTerminate);
    };
    Slider.prototype.componentWillUnmount = function () {
        var dom = this.containerRef.current;
        dom.removeEventListener('touchmove', this.handleTouchMove);
        dom.removeEventListener('touchend', this.handleTouchTerminate);
        dom.removeEventListener('touchcancel', this.handleTouchTerminate);
    };
    Slider.prototype.checkParams = function () {
        var _a = this.props, min = _a.min, max = _a.max, step = _a.step;
        helper_1.assert(min < max, 'expected: min < max');
        helper_1.assert(step >= 0, 'expected: step >= 0');
        if (step > 0) {
            helper_1.assert(helper_1.canBeDivided(max - min, step), 'expected: max - min can be divided by step');
        }
        var defaultValue = this.props.defaultValue;
        if (typeof defaultValue !== 'number') {
            return;
        }
        helper_1.assert(defaultValue >= min && defaultValue <= max, 'expected: min <= defaultValue <= max');
        var relativeValue = defaultValue - min;
        if (step > 0) {
            helper_1.assert(helper_1.canBeDivided(relativeValue, step), 'expected: defaultValue matches step constraint');
        }
    };
    Slider.prototype.getEventPosition = function (event) {
        var item;
        if (event.touches) {
            item = event.touches.item(0);
        }
        else {
            item = event;
        }
        var clientX = item.clientX, clientY = item.clientY;
        return this.isHorizontal ? clientX : clientY;
    };
    Slider.prototype.setStateByPosition = function (position, callback) {
        if (callback === void 0) { callback = helper_1.emptyFn; }
        var _a = this.props, step = _a.step, onChange = _a.onChange, min = _a.min;
        var length = this.getLength();
        var correctedPosition = helper_1.castInto(position, [0, length]);
        var roundedOffset = 0;
        var relativeValue = correctedPosition / length * this.valueSpan;
        if (step > 0) {
            var roundedValue = helper_1.roundByStep(relativeValue, step);
            roundedOffset = (this.isHorizontal ? 1 : -1) * (roundedValue - relativeValue) / this.valueSpan * length;
            relativeValue = roundedValue;
        }
        var nextValue = relativeValue + min;
        if (nextValue !== this.state.currentValue) {
            this.setState({ currentValue: nextValue }, function () {
                onChange(nextValue);
                callback(nextValue);
            });
            return { isValid: true, roundedOffset: roundedOffset };
        }
        return { isValid: false, roundedOffset: roundedOffset };
    };
    Slider.prototype.getValuePercentage = function (value) {
        return (value - this.props.min) / this.valueSpan;
    };
    Slider.prototype.render = function () {
        return theme_1.consumeTheme(this.themedRender);
    };
    return Slider;
}(React.Component));
exports.default = Slider;
Slider.defaultProps = {
    prefixCls: 'dui-m-slider',
    min: 0,
    max: 100,
    step: 0,
    onChange: helper_1.emptyFn,
    onChangeEnd: helper_1.emptyFn,
    orientation: 'horizontal',
};
